/**
 * Copyright ToolBelt Data Inc., 2020 All Rights Reserved
 */

import _ from 'lodash';
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import React, { Component, useEffect, useState } from 'react';
import { Row, Col, Button, Form, FormControl } from 'react-bootstrap';

import './CreateInputContainer.scss';

import {
    createInput, getMappings, getS3Files, getS3ObjectHeader, updateMappedToAttributes, resetCreateInputState, changeInputChannel, setAlert
} from "./createInputSlice";
import {
    getInputSchemas, updateMappedSelectedFileFields, updateAllMappedSelectedFileFields, browseS3ForSourceData, previewDataOnS3ForSourceData, clearS3Files, clearState
} from "../sources/sourceSlice";

import Alert from 'react-bootstrap/Alert';
import { filter, values, find, concat, difference, intersectionWith, isEmpty, sortBy } from 'lodash';
import { INDICATOR_TYPES, getIndicatorTypeById } from '../../common/metadata/Indicators';
import config from '../../config';
import * as Api from '../../common/Api';
import { useCSVReader } from 'react-papaparse';
import Image from 'react-bootstrap/Image';
import BrowserWindowImage from '../../common/assets/img/ToolbeltIcons_Artboard_17.png';
import Container from "../../common/components/layout/Container";
import BreadCrumb from "../../common/components/BreadCrumb";
import PanelHeader from "../../common/components/layout/PanelHeader";
import Panel from "../../common/components/layout/Panel";
import SpinnerOverlay from "../../common/components/SpinnerOverlay";
import FormContainer from "../../common/components/layout/FormContainer";
import FormSelect from "../../common/components/form/FormSelect";
import FormAsyncSelect from "../../common/components/form/FormAsyncSelect";
import FormTextInput from "../../common/components/FormTextInput";
import FormTextArea from "../../common/components/form/FormTextArea";
import FormRadioGroup from "../../common/components/form/FormRadioGroup";
import CheckBox from "../../common/components/CheckBox";
import FormNumericInput from "../../common/components/FormNumericInput";
import SectionTogglePanel from "../../common/components/SectionTogglePanel";
import DataPreview from "../../common/components/DataPreview";
import HelpPanel from "../../common/components/HelpPanel";
import styled from "styled-components";
import FormLabel from "../../common/components/form/FormLabel";
import * as SourceTypes from "../sources/SourceTypes";

import { FileTreeBrowser } from "../../common/components/FileTreeBrowser";

const SourceDrop = styled.div`
  display: grid;
  justify-items: center;
  text-align: center;
  width: 100%;
  grid-template-columns: 1fr;

  label {
    margin-bottom: 0;
    font-size: 14px;
    cursor: pointer;
  }
`;


const StyledRow = styled(Row)`
    padding-bottom: 0 !important;
    margin-bottom: 0 !important;
`;

const CustomTooltip = styled.div`
  position: relative;
  display: inline-block;
  width: 100%;
  
  .tooltip-content {
    visibility: hidden;
    opacity: 0;
    position: absolute;
    z-index: 1000;
    bottom: 125%;
    left: 50%;
    transform: translateX(-50%);
    background-color: ${props => props.bg || '#fff5f5'};
    color: ${props => props.fg || '#e53e3e'};
    border: 1px solid ${props => props.border || '#fed7d7'};
    border-radius: 6px;
    padding: 8px 12px;
    font-size: 0.875rem;
    white-space: nowrap;
    box-shadow: 0 3px 12px rgba(0,0,0,0.15);
    transition: opacity 0.3s, visibility 0.3s;
    max-width: 300px;
    white-space: normal;
    word-wrap: break-word;
  }
  
  .tooltip-content::after {
    content: "";
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: ${props => props.border || '#fed7d7'} transparent transparent transparent;
  }
  
  &:hover .tooltip-content {
    visibility: visible;
    opacity: 1;
  }
  
  .scrollable-content {
    width: 100%;
    overflow-x: auto;
    overflow-y: hidden;
    white-space: nowrap;
  }
`;

const MappingContainer = styled.div`
  border: 1px dashed #CCC;
  padding: 20px;
`;

const EmptyStateContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100px;
  /* Force recompilation */
`;

const MappingHeader = styled.div`
  font-weight: bold;
  display: grid;
  grid-template-columns: minmax(220px, 1fr) minmax(220px, 1fr) minmax(0, 1fr);
  grid-gap: 40px;
  margin-bottom: 15px;
`;

const MappingRow = styled.div`
  display: grid;
  grid-template-columns: minmax(220px, 1fr) minmax(220px, 1fr) minmax(0, 1fr);
  grid-gap: 40px;
  margin-bottom: 15px;
`;

const StyledFileTreeBrowser = styled.div`
  border: dashed 3px #2d5d7e;
  border-radius: 1px;
  height: 100%;
`;


const ErrorMessage = styled.div`
  color: #e53e3e;
  font-size: 0.875rem;
  font-weight: 500;
  display: flex;
  align-items: center;
  min-width: 0; // allow shrink inside grid cell
  max-width: 100%;
`;

const uploadRef = React.createRef();
// Note: CSVReader in v4.x doesn't use refs - we track file state via acceptedFile prop

export default class CreateInputContainer extends Component {
    static propTypes = {};
    static defaultProps = {};

    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        return (
            <CreateInput />
        )
    }
}

function CreateInput(props) {
    const createInputState = useSelector(state => state.createInput);
    const sourceState = useSelector(state => state.source);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const s3Files = sourceState.s3Files;
    const { CSVReader } = useCSVReader();

    const productOptions = [
        { value: 'b2b', label: 'b2b' },
        { value: 'tcu', label: 'tcu' }
    ];

    const dataTypes = [
        { value: 'csv', label: 'csv' },
        { value: 'avro', label: 'avro' },
        { value: 'parquet', label: 'parquet' }
    ];

    const dataChannels = [
        { value: 'upload', label: 'Upload' },
        { value: 's3', label: <>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;S3&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</> }
    ];

    const [mapping, setMapping] = useState({});
    const [mappingAttributes, setMappingAttributes] = useState(undefined);

    const [showAlert, setShowAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const [showSuccess, setShowSuccess] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');

    // Form
    const [sourcesSearch, setSourcesSearch] = useState('');
    const [formValid, setFormValid] = useState(true);
    const [source, setSource] = useState('');
    const [type, setType] = useState('');
    const [inputType, setInputType] = useState('');
    const [name, setName] = useState('');
    const [label, setLabel] = useState('');
    const [description, setDescription] = useState('');
    const [url, setUrl] = useState('');
    const [qualityScore, setQualityScore] = useState('');
    const [authoritative, setAuthoritative] = useState(false);
    const [isPublic, setIsPublic] = useState(true);
    const [products, setProducts] = useState([productOptions[0]]);
    const [indicators, setIndicators] = useState(null);
    const [dataType, setDataType] = useState(dataTypes[0]);
    const [fileSelected, setFileSelected] = useState(false);
    const [uploadFile, setUploadFile] = useState('');
    const [inputChannel, setInputChannel] = useState("upload");
    const [uploadFileHeaders, setUploadFileHeaders] = useState('');
    const [isFileValid, setIsFileValid] = useState(true);
    const [fileErrorMessage, setFileErrorMessage] = useState(undefined);
    const [mappingErrors, setMappingErrors] = useState({});
    const [originalSourceMapping, setOriginalSourceMapping] = useState({}); // property -> fieldName
    const [invalidMappings, setInvalidMappings] = useState(new Set());
    const [s3BaseKey, setS3BaseKey] = useState('');
    
    // Field validation state
    const [nameInValid, setNameInValid] = useState(false);
    const [labelInValid, setLabelInValid] = useState(false);
    const [urlInValid, setUrlInValid] = useState(false);
    const [qualityScoreInValid, setQualityScoreInValid] = useState(false);
    const [validationLifecycle, setValidationLifecycle] = useState({
        state: 'idle',  // 'idle' | 'pending' | 'ready' | 'validated'
        lastValidated: null,
        pendingSources: new Set()  // Track what's still loading: 'fileUpload', 'sourceSelection', 's3Selection'
    });

    // Preview and Mapping state
    const [selectedFile, setSelectedFile] = useState(null);
    const [selectedFileFields, setSelectedFileFields] = useState([]);
    const [selectedFileData, setSelectedFileData] = useState([]);
    const [selectedInputSchema, setSelectedInputSchema] = useState(null);
    const [dataPickerOrPreviewAlertMessage, setDataPickerOrPreviewAlertMessage] = useState('');
    const [sourceMissingPreview, setSourceMissingPreview] = useState(false);
    const [sourceMissingMappings, setSourceMissingMappings] = useState(false);
    
    // Computed values for mapping
    const mappableInputSchemaProperties = selectedInputSchema && selectedInputSchema.properties.length > 0 ? sortBy(selectedInputSchema.properties, ['ordinalPosition']) : [];
    const mappedSelectedFileFields = sourceState.mappedSelectedFileFields || [];

    // Clear state and load input schemas on component mount/unmount
    useEffect(() => {
        dispatch(clearState({ clearMappings: true }));
        dispatch(getInputSchemas());
        
        // Cleanup on unmount
        return () => {
            dispatch(clearState({ clearMappings: true }));
            // Clear local state
            setSelectedFile(null);
            setSelectedFileFields([]);
            setSelectedFileData([]);
            setMappingErrors({});
            setOriginalSourceMapping({});
        };
    }, []);

    // Validate mappings using state machine pattern - no setTimeout needed!
    useEffect(() => {
        if (validationLifecycle.state === 'ready') {
            const hasFileData = uploadFileHeaders || selectedFileFields.length > 0;
            const hasMappings = mappedSelectedFileFields.length > 0 || Object.keys(originalSourceMapping).length > 0;
            
            if (hasFileData && hasMappings) {
                validateMappingsAgainstFile();
                setValidationLifecycle(prev => ({
                    ...prev,
                    state: 'validated',
                    lastValidated: Date.now()
                }));
            } else {
                // Nothing to validate, go back to idle
                setMappingErrors({});
                setValidationLifecycle(prev => ({
                    ...prev,
                    state: 'idle'
                }));
            }
        }
    }, [validationLifecycle.state, mappedSelectedFileFields, uploadFileHeaders, selectedFileFields, originalSourceMapping]);

    // Update selected input schema when type changes or input schemas are loaded
    useEffect(() => {
        if (sourceState.inputSchemas && type) {
            const inputType = SourceTypes.getTypeById(type).inputType;
            const schema = sourceState.inputSchemas.find(schema => schema.inputType === inputType);
            setSelectedInputSchema(schema);
        }
    }, [sourceState.inputSchemas, type]);

    // Handle S3 preview data
    useEffect(() => {
        // Only process S3 preview data when in S3 mode
        if (inputChannel === 's3' && sourceState.previewFromS3 && sourceState.previewFromS3.records) {
            // Mark S3 selection as pending
            setValidationLifecycle(prev => ({
                ...prev,
                state: 'pending',
                pendingSources: new Set([...prev.pendingSources, 's3Selection'])
            }));
            
            setSelectedFile({ name: sourceState.previewFromS3.key || 'S3 File' });
            setSelectedFileFields(sourceState.previewFromS3.fields);
            setSelectedFileData(sourceState.previewFromS3.records.map((record) => Object.values(record)));
            setFileSelected(true);
            
            // Mark S3 selection as complete
            setValidationLifecycle(prev => {
                const newSources = new Set(prev.pendingSources);
                newSources.delete('s3Selection');
                return {
                    ...prev,
                    state: newSources.size === 0 ? 'ready' : 'pending',
                    pendingSources: newSources
                };
            });
        }
    }, [inputChannel, sourceState.previewFromS3]);





    const loadSourceOptions = async () => {
        const GET_SOURCE_URL = `${config.services.ATLAS.apiUrl}/managed-sources`;
        const query = {
            filter: {
                where: {
                    and: [
                        {
                            or: [{
                                name: {
                                    ilike: `%${sourcesSearch ? sourcesSearch : ''}%`
                                }
                            },
                            {
                                description: {
                                    ilike: `%${sourcesSearch ? sourcesSearch : ''}%`
                                }
                            },
                            {
                                label: {
                                    ilike: `%${sourcesSearch ? sourcesSearch : ''}%`
                                }
                            }
                            ]
                        }
                    ]
                },
                order: [`created DESC`],
            }
        }
        if (!sourcesSearch) query.filter.where = undefined;
        const sources = await Api.get(true, GET_SOURCE_URL, query);
        const returnSources = sources.filter((source) => !source.archived);
        return returnSources;
    }

    const handleSourceInputChange = (newValue) => {
        if (newValue.length >= 3) setSourcesSearch(newValue);
    };

    const handleSourceOnChange = async (s) => {

        // TODO: This is crude, a hack to get inputs back up and working
        
        if (!s) return reset();
        const GET_SOURCE_DATA_URL = `${config.services.ATLAS.apiUrl}/managed-source-data`;
        const query = {
            filter: {
                where: {
                    and: [
                        {
                            sourceId: s.id,
                        },
                        {
                            current: true,
                        }
                    ]
                },
            }
        }
        const foundSourceData = await Api.get(true, GET_SOURCE_DATA_URL, query);
        console.log('foundSourceData', foundSourceData);
        console.log('Source object:', s);
        
        // Note: mapping and attributes come from sourceData.inputMapping, not from source
        let mapping;
        if (foundSourceData && foundSourceData.inputMapping) {
            mapping = foundSourceData.inputMapping;
        }
        
        let attributes = [];
        if (foundSourceData && foundSourceData.inputMapping?.attributes) {
            attributes = foundSourceData.inputMapping.attributes;
        }

        setSource(s);
        setLabel(s.label);
        setQualityScore(s.qualityScore);
        setAuthoritative(s.authoritative);
        setType(s.type);
        setDescription(s.description);
        setUrl(s.url);
        setInputType(SourceTypes.getTypeById(s.type).inputType);
        setIsPublic(s.public);
        setProducts(() => {
            if (!s.products || s.products.length === 0) return setProducts([productOptions[0]]);
            return s.products.map((p) => (find(productOptions, { value: p })))
        });
        setIndicators(() => {
            if (!s.indicators || s.indicators.length === 0) return setIndicators(null);
            return s.indicators.map((i) => {
                const indicator = getIndicatorTypeById(i);
                if (indicator) {
                    return {
                        value: indicator.id,
                        label: indicator.display
                    }
                }
            })
        });
        setSource(s);
        setMapping(mapping);
        setMappingAttributes(attributes);

        // Mark source selection as pending in validation lifecycle
        setValidationLifecycle(prev => ({
            ...prev,
            state: 'pending',
            pendingSources: new Set([...prev.pendingSources, 'sourceSelection'])
        }));
        
        // Load mapping from the source (source acts as template for mappings only)
        // Note: Preview data is NOT stored in the API, so user must upload/select file for preview
        let hasMappings = false;
        
        // Handle both array and single object responses
        let sourceData = null;
        if (foundSourceData) {
            if (Array.isArray(foundSourceData) && foundSourceData.length > 0) {
                sourceData = foundSourceData[0]; // Get the first record from array
            } else if (!Array.isArray(foundSourceData)) {
                sourceData = foundSourceData; // Single object response
            }
        }
        
        if (sourceData) {
            console.log('Processing sourceData:', sourceData);
            console.log('Available properties in sourceData:', Object.keys(sourceData));
            
            // Set existing field mappings from source template
            if (sourceData.inputMapping && sourceData.inputMapping.attributes) {
                console.log('Setting field mappings from sourceData.inputMapping.attributes:', sourceData.inputMapping.attributes);
                setOriginalSourceMapping(sourceData.inputMapping.attributes);
                // Convert field mappings to the format expected by Redux
                const mappedFields = Object.entries(sourceData.inputMapping.attributes).map(([property, fieldName]) => {
                    // Find the schema property to get the required flag
                    const schema = sourceState.inputSchemas?.find(schema => schema.inputType === SourceTypes.getTypeById(s.type).inputType);
                    const schemaProperty = schema?.properties?.find(prop => prop.property === property);
                    return {
                        property: property,
                        selectedFileField: fieldName,
                        required: schemaProperty?.required || false
                    };
                });
                console.log('Dispatching mapped fields:', mappedFields);
                dispatch(updateAllMappedSelectedFileFields(mappedFields));
                hasMappings = true;
            } else {
                console.log('No inputMapping.attributes found in sourceData');
            }
        }
        
        // Set flags for missing data
        // Note: Preview data is never stored in API, so always missing until user uploads file
        setSourceMissingPreview(true);
        setSourceMissingMappings(!hasMappings);

        // Set the input schema based on the source type
        if (sourceState.inputSchemas && s.type) {
            const inputType = SourceTypes.getTypeById(s.type).inputType;
            const schema = sourceState.inputSchemas.find(schema => schema.inputType === inputType);
            setSelectedInputSchema(schema);
        }

        if (fileSelected) {
            validateFileInput(attributes, uploadFileHeaders?.data);
        }
        
        // Mark source selection as complete in validation lifecycle
        setValidationLifecycle(prev => {
            const newSources = new Set(prev.pendingSources);
            newSources.delete('sourceSelection');
            return {
                ...prev,
                state: newSources.size === 0 ? 'ready' : 'pending',
                pendingSources: newSources
            };
        });
    };

    const handleOnFileDrop = (data, meta) => {
        setFileErrorMessage(null);
        setIsFileValid(true);
        setUploadFile(null);
        setFileSelected(false);
        setUploadFileHeaders(null);

        const input = uploadRef.current;
        // console.log('data', data);
        // console.log('meta', meta);
        // Perform the upload (async)
        const sizeLimit = config.constants.LIMIT_FILE_UPLOAD;
        if (meta && meta.size > (sizeLimit * 1000000)) {
            input.state.files = null;
            setShowAlert(true);
            setAlertMessage('File size is not support.');
            // setTimeout(() => setShowAlert(false), 5000);

            return;
        }

        if (data?.length > 0) {
            setUploadFileHeaders(data[0]);
        }

        if (input && input.state && input.state.files) {
            // Why are we doing this and not getting it from meta?
            setUploadFile(input.state.files[0]);
            setFileSelected(true);
        }

        // Set Headers (for mapping)
        validateFileInput(mappingAttributes, data[0]?.data);
    }

    const validateFileInput = (mappingAttributes, fileHeaderColumns) => {
        if (mappingAttributes) {
            // validate input file against the mapping data from selected source
            if (Object.entries(mappingAttributes).length < fileHeaderColumns?.length) {
                setFileErrorMessage('More columns are in the input file than specified in the source schema.');
                setIsFileValid(true);
            }

            let fileIsValid = true
            Object.entries(mappingAttributes).map(([key, value], idx) => {
                if (!_.includes(fileHeaderColumns, value)) {
                    fileIsValid = false;
                }
            });
            if (!fileIsValid) {
                setIsFileValid(false);
                setFileErrorMessage('The file is missing columns required by the source schema');
            }
        }
    }

    const handleOnFileError = (err, file, inputElem, reason) => {
        console.error(err);
    }

    const handleOnRemoveFile = (data) => {
        setUploadFile('');
    }

    const handleOnMappingSelect = (attribute, header, required) => {
        dispatch(updateMappedToAttributes({ attribute: attribute, header: header, required: required }));
    }

    // New handler functions for preview and mapping
    const handleOnUploadFileDrop = (results, file) => {
        // results is a ParseResult object with { data, errors, meta }
        // file is the File object
        if (file && file.type !== 'text/csv' && !file.name.toLowerCase().endsWith('.csv')) {
            setDataPickerOrPreviewAlertMessage('File type is not supported. Only CSV files are currently supported.');
            return;
        }

        if (file && file.size > (32 * 1000000)) {
            setDataPickerOrPreviewAlertMessage('Whoa. Thats a big file. This is just sample data for setting up the mapping. Let\'s keep it under 32MB.');
            return;
        }

        // Mark file upload as pending in validation lifecycle
        setValidationLifecycle(prev => ({
            ...prev,
            state: 'pending',
            pendingSources: new Set([...prev.pendingSources, 'fileUpload'])
        }));

        if (file) {
            setSelectedFile(file);
            setUploadFile(file);
            setFileSelected(true);
        }

        // Set Headers (selected file fields) (for mapping)
        if (results && results.data && results.data.length > 0) {
            setSelectedFileFields(results.data[0]);
            setSelectedFileData(results.data.slice(1));
            setUploadFileHeaders({data: results.data[0]});
        }
        
        // Mark file upload as complete in validation lifecycle
        setValidationLifecycle(prev => {
            const newSources = new Set(prev.pendingSources);
            newSources.delete('fileUpload');
            return {
                ...prev,
                state: newSources.size === 0 ? 'ready' : 'pending',
                pendingSources: newSources
            };
        });
    };

    const handleOnUploadFileError = (file, event) => {
        console.error('File upload error:', file, event);
        setDataPickerOrPreviewAlertMessage(`There was an error uploading the file. Please try again.`);
        setSelectedFile(null);
        setUploadFile('');
        setFileSelected(false);
        setUploadFileHeaders(null);
    };

    const handleOnUploadRemoveFile = (data) => {
        setSelectedFile(null);
        setSelectedFileFields([]);
        setSelectedFileData([]);
        setUploadFile('');
        setFileSelected(false);
        setUploadFileHeaders(null);
        
        // Clear validation errors when file is removed
        setMappingErrors({});
        setInvalidMappings(new Set());
    };

    const handleOnMappingSelectNew = (property, selectedFileField, required) => {
        dispatch(updateMappedSelectedFileFields({ property: property, selectedFileField: selectedFileField, required: required }));
        
        // Clear any existing error for this property since user selected a valid field from the file
        setMappingErrors(prev => {
            const newErrors = { ...prev };
            delete newErrors[property];
            return newErrors;
        });
        
        // Trigger validation when user changes mapping
        setValidationLifecycle(prev => ({
            ...prev,
            state: 'ready'
        }));
    };

    const handleMapByName = () => {
        if (!selectedInputSchema) console.warn('there are no mapping attributes to auto fill with');
        if (!selectedFileFields) console.warn('there are no file headers map to');
        const mapped = intersectionWith(selectedInputSchema.properties, selectedFileFields, (arrVal, othVal) => {
            if (arrVal.property === othVal) return true;
        });
        const mappedSelectedFileFields = mapped.map((m) => ({ property: m.property, selectedFileField: m.property, required: m.required }));
        dispatch(updateAllMappedSelectedFileFields(mappedSelectedFileFields));
        
        // Trigger validation when mappings change
        setValidationLifecycle(prev => ({
            ...prev,
            state: 'ready'
        }));
    };

    const onFileTreeBrowserFileSelected = (fileKey, dataTypeValue) => {
        dispatch(previewDataOnS3ForSourceData({ s3BaseKey, prefix: fileKey.id, dataType: dataTypeValue }));
        // Set uploadFile with the folder/prefix path for downstream processing
        setUploadFile({ name: fileKey.id });
    };

    const isValid = () => {
        if (!source) return false;
        if (!type) return false;
        if (!name) return false;
        if (!label) return false;
        if (qualityScoreInValid) return false; // Check validation state
        if (qualityScore) {
            const _qualityScore = parseFloat(qualityScore);
            if (isNaN(_qualityScore) || _qualityScore < 0 || _qualityScore > 1) return false;
        }
        if (!mappingAttributes)
            return false;

        if ((inputChannel === "upload" && !uploadFile) ||
            (inputChannel === "s3" && !fileSelected)) {
            setFileErrorMessage('Input file is required');
            setIsFileValid(false);
            return false;
        }
        
        // Check for headers based on channel - CSV uses uploadFileHeaders, S3 uses selectedFileFields
        const hasHeaders = inputChannel === 'upload' 
            ? (uploadFileHeaders && uploadFileHeaders.data && uploadFileHeaders.data.length > 0)
            : (selectedFileFields && selectedFileFields.length > 0);
            
        if (!hasHeaders) {
            setFileErrorMessage('The file is missing columns required by the source schema');
            setIsFileValid(false);
            return false;
        }
        
        // validate input file against the current mapping state
        const currentMappings = mappedSelectedFileFields.filter(m => m.selectedFileField);
        if (currentMappings.length === 0) {
            setFileErrorMessage('Please map at least one field before submitting');
            setIsFileValid(false);
            return false;
        }
        
        // Check if there are any mapping errors
        if (Object.keys(mappingErrors).length > 0) {
            setFileErrorMessage('Please fix the mapping errors highlighted below');
            setIsFileValid(false);
            return false;
        }

        return true;
    };

    const reset = () => {
        setSource('');
        setType('');
        setInputType('');
        setName('');
        setLabel('');
        setDescription('');
        setQualityScore('');
        setAuthoritative(false);
        setIsPublic(true);
        setProducts([productOptions[0]]);
        setIndicators([]);
        setUploadFile('');
        setUploadFileHeaders(undefined);
        setFileSelected(false);
        setMappingAttributes(undefined);
        setIsFileValid(true);
        setFileErrorMessage(undefined);
        setMappingErrors({});
        setInvalidMappings(new Set());
        setNameInValid(false);
        setLabelInValid(false);
        setUrlInValid(false);
        setQualityScoreInValid(false);
        dispatch(resetCreateInputState());
    }

    // Validation functions
    const nameValidate = (name) => {
        if (!name) {
            setNameInValid(true); // Blank value IS invalid (name is required)
            return;
        }
        const nameRegex = /^[A-Za-z0-9_() -]+$/;
        const isValidFormat = nameRegex.test(name);
        setNameInValid(!isValidFormat);
    }

    const labelValidate = (label) => {
        if (!label) {
            setLabelInValid(true); // Blank value IS invalid (label is required)
            return;
        }
        const labelRegex = /^[A-Za-z0-9_() -]+$/;
        const isValidFormat = labelRegex.test(label);
        setLabelInValid(!isValidFormat);
    }

    const urlValidate = (url) => {
        if (!url) {
            setUrlInValid(false);
            return;
        }
        if (url === 'NA') {
            setUrlInValid(false);
            return;
        }
        const urlRegex = /^(http:\/\/|https:\/\/)/;
        const isValidFormat = urlRegex.test(url);
        setUrlInValid(!isValidFormat);
    }

    const qualityScoreValidate = (qualityScore) => {
        // Quality score is optional, so blank is valid
        if (!qualityScore && qualityScore !== 0) {
            setQualityScoreInValid(false);
            return;
        }
        const numValue = typeof qualityScore === 'string' ? parseFloat(qualityScore) : qualityScore;
        if (isNaN(numValue)) {
            setQualityScoreInValid(true);
            return;
        }
        const isInvalidValue = (numValue < 0 || numValue > 1);
        setQualityScoreInValid(isInvalidValue);
    }

    const handleChangeDataType = (newDataType) => {
        setDataType(newDataType);
        if (newDataType.value === dataType.value) {
            return;
        }
        if (newDataType.value === 'csv') {
            setInputChannel('upload');
            setSelectedFile(null);
            setSelectedFileFields([]);
            setSelectedFileData([]);
            dispatch(clearS3Files());
        } else {
            let s3BaseKey = '';
            if (newDataType.value === 'avro') {
                s3BaseKey = `${config.sourceInput.s3BaseAvroBucket}${config.sourceInput.s3BaseAvroPath}`;
                setS3BaseKey(s3BaseKey);
            } else if (newDataType.value === 'parquet') {
                s3BaseKey = `${config.sourceInput.s3BaseParquetBucket}${config.sourceInput.s3BaseParquetPath}`;
                setS3BaseKey(s3BaseKey);
            }
            setInputChannel('s3');
            setSelectedFile(null);
            setSelectedFileFields([]);
            setSelectedFileData([]);
            dispatch(browseS3ForSourceData({ dataType: newDataType.value, s3BaseKey: s3BaseKey }));
        }
    }

    const onFileSelected = (fileKey, dataTypeValue) => {
        if (!dataTypeValue) {
            console.warn('No data type selected');
            return;
        }
        dispatch(getS3ObjectHeader({ objectKey: fileKey, type: dataTypeValue }));
        setFileSelected(true);
        //Check back here on whether this is correct for setting the defRef
        let localUploadFile = { name: fileKey };
        setUploadFile(localUploadFile);
    }

    const validateMappingsAgainstFile = () => {
        const errors = {};
        
        // Check all currently mapped fields against the uploaded file
        mappedSelectedFileFields.forEach(mapping => {
            // Check if required field is left blank
            if (mapping.required && !mapping.selectedFileField) {
                errors[mapping.property] = `Required field "${mapping.property}" must be mapped to a column`;
            }
            // Check if source has a mapping but input field is left blank
            else if (originalSourceMapping && originalSourceMapping[mapping.property] && !mapping.selectedFileField) {
                errors[mapping.property] = `Source expects "${originalSourceMapping[mapping.property]}" but no mapping is set`;
            }
            // Check if selected field exists in the file
            else if (mapping.selectedFileField) {
                const foundKey = isKeyFoundInFileHeader(mapping.selectedFileField);
                if (!foundKey) {
                    errors[mapping.property] = `"${mapping.selectedFileField}" not found in uploaded file`;
                }
            }
        });
        
        // Also check if source has mappings that are completely missing from input mappings
        if (originalSourceMapping && Object.keys(originalSourceMapping).length > 0) {
            const inputMappingMap = {};
            mappedSelectedFileFields.forEach(m => {
                inputMappingMap[m.property] = m;
            });
            
            Object.keys(originalSourceMapping).forEach(property => {
                // If source has a mapping for this property but it's not in input mappings at all
                const inputMapping = inputMappingMap[property];
                if (!inputMapping) {
                    errors[property] = `Source expects "${originalSourceMapping[property]}" but no mapping is set`;
                }
            });
        }
        
        setMappingErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const convertMappingsToDataMapping = () => {
        const attributes = {};
        mappedSelectedFileFields.forEach(mapping => {
            if (mapping.selectedFileField) {
                attributes[mapping.property] = mapping.selectedFileField;
            }
        });
        return { attributes };
    };

    const handleCreateInput = async () => {
        if (!isValid()) {
            setFormValid(false);
            setAlertMessage('Form is not valid. Please check that all required fields are filled in correctly.');
            setShowAlert(true);
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: 'smooth'
            });
            console.warn('Form is not valid. source, type, name, label, upload file and mapping are required');
        } else {
            setFormValid(true);
            setAlertMessage('');
            setShowAlert(false);
            const data = {
                source: source,
                uploadedFile: uploadFile,
                mapping: mapping,
                input: {
                    sourceId: source.id,
                    type: SourceTypes.getTypeById(type).inputType,
                    name: name.trim(),
                    label: label ? label.trim() : undefined,
                    description: description ? description.trim() : undefined,
                    url: url ? url.trim() : undefined,
                    qualityScore: !qualityScore ? undefined : parseFloat(qualityScore),
                    authoritative: authoritative,
                    public: isPublic,
                    products: products.map((p) => (p.value)),
                    indicators: indicators ? indicators.map((i) => (i.value)) : null,
                    dataMapping: convertMappingsToDataMapping(),
                    dataType: dataType.value,
                    inputChannel: inputChannel
                }
            }
            dispatch(createInput(data));
        }
    };

    useEffect(() => {
        // When open dialog, we clear state.
        if (createInputState.alertMessage) {
            setAlertMessage(createInputState.alertMessage);
            setShowAlert(true);
        }
    }, [createInputState.alertMessage]);

    useEffect(() => {
        // When open dialog, we clear state.
        if (createInputState.successMessage) {
            setSuccessMessage(createInputState.successMessage);
            setShowSuccess(true);
        }
    }, [createInputState.successMessage]);

    useEffect(() => {
        // When open dialog, we clear state.
        if (createInputState.reset) {
            reset()
        }
    }, [createInputState.reset]);

    useEffect(() => {
        if (createInputState.headerList) {
            // const headerArray = [];
            // headerArray.push({data:createInputState.headerList}); //Match the format of the file uploader.
            setUploadFileHeaders({ data: createInputState.headerList });
            if (type) {
                dispatch(getMappings(type.value));
            }

            validateFileInput(mappingAttributes, createInputState.headerList);
        }
    }, [createInputState.headerList]);

    useEffect(() => {
        if (createInputState.mapping) {
            // const headerArray = [];
            // headerArray.push({data:createInputState.headerList}); //Match the format of the file uploader.
            setMapping(createInputState.mapping);
        }
    }, [createInputState.mapping]);

    const breadcrumbItems = [{ label: 'Home', href: '/admin/home', isActive: false }, {
        label: 'Inputs',
        href: '/admin/inputs',
        isActive: false
    }, { label: 'Create Input', href: '', isActive: true }];

    const isKeyFoundInFileHeader = (key) => {
        // For upload files, check uploadFileHeaders
        if (uploadFileHeaders && uploadFileHeaders.data && uploadFileHeaders.data.length > 0 && key) {
            return _.includes(uploadFileHeaders.data, key);
        }
        // For S3 files, check selectedFileFields
        if (selectedFileFields && selectedFileFields.length > 0 && key) {
            return _.includes(selectedFileFields, key);
        }
        return false;
    }

    return (
        <Container>
            <BreadCrumb items={breadcrumbItems}> </BreadCrumb>
            <PanelHeader header={'Create a new Input'} subHeader={'Define your new input, upload your data and map your input to create a new input'} />
            <Panel>
                {createInputState.loading && (
                    <SpinnerOverlay />
                )}
                <Alert
                    variant={"danger"}
                    show={showAlert}
                    onClose={() => setShowAlert(!showAlert)}
                    dismissible
                    transition={false}
                >
                    {alertMessage}
                </Alert>
                <Alert
                    variant={"success"}
                    show={showSuccess}
                    onClose={() => setShowSuccess(!showSuccess)}
                    dismissible
                    transition={false}
                >
                    {successMessage}
                </Alert>
                {sourceMissingMappings && source && (
                    <Alert
                        variant={"warning"}
                        show={true}
                        dismissible={false}
                        transition={false}
                    >
                        <strong>Source Template Incomplete:</strong> The selected source "{source.name}" is missing field mappings. You can still create an input, but you'll need to configure the mapping manually after uploading your data file.
                    </Alert>
                )}
                <FormContainer>
                    <Form noValidate>
                        <Form.Group controlId="createInput">
                            <Row>
                                <Col xl={8} lg={8} md={8} sm={8}>
                                    <StyledRow>
                                        <Col xl={5} lg={6} md={6} sm={6}>
                                            <StyledRow>
                                                <Col xl={12} lg={12} md={12} sm={12}>
                                    <FormAsyncSelect
                                        label={'Source'}
                                        required
                                        isClearable
                                        cacheOptions
                                        defaultOptions
                                        loadOptions={loadSourceOptions}
                                        getOptionLabel={e => `${e.name} (${e.id})`}
                                        getOptionValue={e => e.id}
                                        onChange={handleSourceOnChange}
                                        onInputChange={handleSourceInputChange}
                                        isInvalid={!formValid && !source}
                                                        size={'sm'}
                                        value={source}
                                    />
                                </Col>
                                            </StyledRow>
                                        </Col>
                                        <Col xl={5} lg={6} md={6} sm={6}>
                                            <StyledRow>
                                                <Col xl={12} lg={12} md={12} sm={12}>
                                                    <FormNumericInput
                                                        label={'Quality Score'}
                                                        value={qualityScore}
                                                        onChange={value => {
                                                            setQualityScore(value);
                                                            qualityScoreValidate(value);
                                                        }}
                                                        isInvalid={qualityScoreInValid}
                                                        errorMsg={qualityScoreInValid ? 'Quality Score must be between 0 and 1' : undefined}
                                                        size={'sm'}
                                                        min={0}
                                                        max={1}
                                                        step={0.1}
                                                    />
                                                </Col>
                                            </StyledRow>
                                        </Col>
                                    </StyledRow>
                                    <StyledRow>
                                        <Col xl={11} lg={12} md={12} sm={12}>
                                    <FormTextInput
                                        label={'Type'}
                                        value={type}
                                        size={'sm'}
                                        required
                                        disabled={true}
                                    />
                                </Col>
                                    </StyledRow>
                                    <StyledRow>
                                        <Col xl={11} lg={12} md={12} sm={12}>
                                    <FormTextInput
                                        label={'Input Type'}
                                        value={inputType}
                                        size={'sm'}
                                        required
                                        disabled={true}
                                    />
                                </Col>
                                    </StyledRow>
                                    <StyledRow>
                                        <Col xl={11} lg={12} md={12} sm={12}>
                                    <FormTextInput
                                        label={'Name'}
                                        value={name}
                                        onChange={value => {
                                            setName(value);
                                            nameValidate(value);
                                        }}
                                        isInvalid={(!formValid && !name) || nameInValid}
                                        size={'sm'}
                                        required
                                        errorMsg={nameInValid ? 'Name must match regex ^[A-Za-z0-9_() -]+$' : undefined}
                                    />
                                </Col>
                                    </StyledRow>
                                    <StyledRow>
                                        <Col xl={11} lg={12} md={12} sm={12}>
                                    <FormTextInput
                                        label={'Label'}
                                        value={label}
                                        onChange={value => {
                                            setLabel(value);
                                            labelValidate(value);
                                        }}
                                        isInvalid={(!formValid && !label) || labelInValid}
                                        size={'sm'}
                                        required
                                        errorMsg={labelInValid ? 'Label must match regex ^[A-Za-z0-9_() -]+$' : undefined}
                                    />
                                </Col>
                                    </StyledRow>
                            <Row>
                                        <Col xl={11} lg={12} md={12} sm={12}>
                                    <FormTextArea
                                        label={'Description'}
                                        onChange={value => setDescription(value)}
                                        value={description}
                                                size={'sm'}
                                    />
                                </Col>
                            </Row>
                                    <StyledRow>
                                        <Col xl={11} lg={12} md={12} sm={12}>
                                    <FormTextInput
                                        label={'URL'}
                                        value={url}
                                        onChange={value => {
                                            setUrl(value);
                                            urlValidate(value);
                                        }}
                                        isInvalid={urlInValid}
                                        size={'sm'}
                                        errorMsg={urlInValid ? 'URL must be NA or start with https/http' : undefined}
                                    />
                                </Col>
                                    </StyledRow>
                                    
                                    {/* Attributes */}
                                    <div>
                                        <StyledRow>
                                            <Col xl={11} lg={12} md={12} sm={12}>
                                                <SectionTogglePanel
                                                    title={'Attributes'}
                                                    isExpand={true}
                                                    overflowX={false}
                                                    padding={'0.5em 0.5em 0.5em 0em'}
                                                >
                            <Row>
                                                        <Col xl={12} lg={12} md={12} sm={12}>
                                                            <StyledRow>
                                                                <Col xl={6} lg={6} md={6} sm={6}>
                                    <CheckBox
                                        label={'Authoritative'}
                                        checked={authoritative}
                                        onChange={value => setAuthoritative(value)}
                                    />
                                </Col>
                                                            </StyledRow>
                                                            <StyledRow>
                                                                <Col xl={6} lg={6} md={6} sm={6}>
                                    <CheckBox
                                        label={'Public'}
                                        checked={isPublic}
                                        onChange={value => setIsPublic(value)}
                                    />
                                                                </Col>
                                                            </StyledRow>
                                </Col>
                            </Row>
                                                </SectionTogglePanel>
                                            </Col>
                                        </StyledRow>
                                    </div>
                                    <Row>
                                        <Col xl={11} lg={12} md={12} sm={12}>
                                            <FormSelect
                                                label={'Products'}
                                                options={productOptions}
                                                onChange={(v) => setProducts(v)}
                                                value={products}
                                                isMulti
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xl={11} lg={12} md={12} sm={12}>
                                            <FormSelect
                                                label={'Indicators'}
                                                options={filter(values(INDICATOR_TYPES), (i) => {
                                                    return !!i.display
                                                }).map((t) => ({ value: t.id, label: t.display })
                                                )}
                                                onChange={(v) => {
                                                    v && v.length > 0 ? setIndicators(v) : setIndicators(null);
                                                }}
                                                value={indicators}
                                                isMulti
                                            />
                                        </Col>
                                    </Row>
                                    
                                    {/* Data Configuration */}
                                    <div>
                                        <StyledRow>
                                            <Col xl={11} lg={12} md={12} sm={12}>
                                                <SectionTogglePanel
                                                    title={'Data Configuration'}
                                                    isExpand={true}
                                                    overflowX={false}
                                                    padding={'0.5em 0.5em 0.5em 0em'}
                                                >
                            <Row>
                                                        <Col xl={12} lg={12} md={12} sm={12}>
                                    <FormSelect
                                        label={'Data Type'}
                                        options={dataTypes}
                                        onChange={(v) => handleChangeDataType(v)}
                                        value={dataType}
                                                                size={'sm'}
                                    />
                                </Col>
                            </Row>
                                                    <StyledRow>
                                                        <Col xl={12} lg={12} md={12} sm={12}>
                                                            <FormRadioGroup
                                                                id={'DataChannelSelection'}
                                                                name={'DataChannelSelection'}
                                                                label={'Data Channel'}
                                                                value={inputChannel}
                                                                items={dataChannels}
                                                                onChange={selectedValue => console.log('Choice restricted by data type.')}
                                                                radioButton
                                                            />
                                                        </Col>
                                                    </StyledRow>
                                                </SectionTogglePanel>
                                            </Col>
                                        </StyledRow>
                                    </div>
                            {inputChannel === 'upload' && (
                                <StyledRow>
                                    <Col xl={12} lg={12} md={12} sm={12}>
                                        <CSVReader
                                            config={{ preview: 51 }}
                                            onUploadAccepted={handleOnUploadFileDrop}
                                            onUploadRejected={handleOnUploadFileError}
                                            accept=".csv"
                                            maxSize={32 * 1000000}
                                        >
                                            {({
                                                getRootProps,
                                                acceptedFile,
                                                ProgressBar,
                                                getRemoveFileProps,
                                                Remove,
                                            }) => (
                                                <>
                                                    <div
                                                        {...getRootProps()}
                                                        style={{
                                                            border: 'dashed',
                                                            borderColor: '#ccc',
                                                            borderRadius: '1px',
                                                            borderWidth: '1px',
                                                            marginBottom: 10,
                                                            height: acceptedFile ? '200px' : '400px',
                                                            cursor: 'pointer',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            padding: '20px',
                                                        }}
                                                    >
                                                        <SourceDrop>
                                                            <Image
                                                                src={BrowserWindowImage}
                                                                width="110"
                                                                alt="Browser Window Image"
                                                                fluid
                                                            />
                                                            <FormLabel>
                                                                Drag n' drop your file here or click to select your file
                                                            </FormLabel>
                                                        </SourceDrop>
                                                    </div>
                                                    {acceptedFile && (
                                                        <div style={{ marginBottom: '10px' }}>
                                                            <div style={{
                                                                color: '#2d5d7e',
                                                                backgroundColor: '#ffffff',
                                                                borderRadius: '1px',
                                                                borderWidth: '1px',
                                                                fontSize: 14,
                                                                lineHeight: 1,
                                                                padding: '0 0.4em',
                                                                marginBottom: '0.5em',
                                                            }}>
                                                                {acceptedFile.name}
                                                            </div>
                                                            <div style={{
                                                                color: '#6c757d',
                                                                backgroundColor: '#ffffff',
                                                                borderRadius: '1px',
                                                                borderWidth: '1px',
                                                                lineHeight: 1,
                                                                marginBottom: '0.5em',
                                                                padding: '0 0.4em',
                                                            }}>
                                                                {(acceptedFile.size / 1024).toFixed(2)} KB
                                                            </div>
                                                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                                                <ProgressBar style={{ backgroundColor: '#EE5A38' }} />
                                                                <button
                                                                    {...getRemoveFileProps()}
                                                                    onClick={(e) => {
                                                                        getRemoveFileProps().onClick(e);
                                                                        handleOnUploadRemoveFile(null);
                                                                    }}
                                                                    style={{
                                                                        color: '#EE5A38',
                                                                        background: 'none',
                                                                        border: 'none',
                                                                        cursor: 'pointer',
                                                                        padding: '5px',
                                                                    }}
                                                                >
                                                                    <Remove />
                                                                </button>
                                                            </div>
                                                        </div>
                                                    )}
                                                </>
                                            )}
                                        </CSVReader>
                                        {/* File Error Message */}
                                        {!isFileValid && fileErrorMessage && (
                                            <Alert
                                                variant="danger"
                                                show={true}
                                                dismissible={false}
                                                transition={false}
                                                style={{ marginTop: '10px' }}
                                            >
                                                <strong>File Validation Error:</strong> {fileErrorMessage}
                                            </Alert>
                                        )}
                                    </Col>
                                </StyledRow>
                            )}
                            {inputChannel === 's3' && (
                                <StyledRow>
                                    <Col xl={12} lg={12} md={12} sm={12}>
                                        <StyledFileTreeBrowser style={{ height: 400, marginBottom: '10px' }}>
                                            <FileTreeBrowser
                                                baseKey={s3BaseKey}
                                                files={s3Files}
                                                onFileAction={(fileKey) => onFileTreeBrowserFileSelected(fileKey, dataType.value)}
                                            />
                                        </StyledFileTreeBrowser>
                                    </Col>
                                </StyledRow>
                            )}
                            {/* Preview */}
                                    <StyledRow>
                                        <Col xl={12} lg={12} md={12} sm={12}>
                                            <DataPreview
                                                fields={selectedFileFields}
                                                data={selectedFileData}
                                                title={`Preview - ${selectedFile?.name || 'No Data'}`}
                                                emptyStateMessage={
                                                    !source 
                                                        ? "Please select a source to preview template data" 
                                                        : sourceMissingPreview 
                                                            ? "Upload your own data file to see a preview."
                                                            : "Please configure your source to preview the data"
                                                }
                                                showRowCount={true}
                                                cellMaxWidth="500px"
                                                truncateLength={75}
                                                selectedFields={mappedSelectedFileFields.map(m => m.selectedFileField).filter(Boolean)}
                                                overrideFields={mappedSelectedFileFields
                                                    .filter(m => originalSourceMapping && originalSourceMapping[m.property] && originalSourceMapping[m.property] !== m.selectedFileField)
                                                    .map(m => m.selectedFileField)
                                                    .filter(Boolean)}
                                                highlightSelectedColumns={true}
                                            />
                                        </Col>
                                    </StyledRow>
                                    {/* Mapping */}
                                    <StyledRow>
                                        <Col xl={12} lg={12} md={12} sm={12}>
                                            <FormLabel>Mapping</FormLabel>
                                            {Object.keys(mappingErrors).length > 0 && (
                                                <Alert variant={"danger"} style={{ margin: '8px 0 12px' }}>
                                                    Some fields expected by the source are not present or selected in the file. Please do one of the following:
                                                    <ul style={{ marginTop: '8px', marginBottom: '0' }}>
                                                        <li>Change mappings below</li>
                                                        <li>Edit or change the source</li>
                                                    </ul>
                                                </Alert>
                                            )}
                                            <MappingContainer>
                                                {(!type || (!selectedFile && mappedSelectedFileFields.length === 0)) && (
                                                    <EmptyStateContainer>
                                                        <FormLabel>
                                                            {!source 
                                                                ? "Please select a source to configure field mappings" 
                                                                : sourceMissingMappings 
                                                                    ? `The selected source "${source.name}" does not have field mappings configured. You'll need to map fields manually after uploading your data file.`
                                                                    : "Please configure your source to see the mappings"
                                                            }
                                                        </FormLabel>
                                                    </EmptyStateContainer>
                                                )}
                                                {type && (selectedFile || mappedSelectedFileFields.length > 0) && (
                                                    <>
                                                        <MappingHeader>
                                                            <div>{`Mappable Properties for Source: ${type.label}`}</div>
                                                            <div>Selected Fields from Configured Source</div>
                                                            <div>Validation</div>
                                                        </MappingHeader>
                                                        {mappableInputSchemaProperties && mappableInputSchemaProperties.map((mp, idx) => {
                                                            const selectedFileField = find(mappedSelectedFileFields, (o) => {
                                                                return o.property === mp.property
                                                            }) && find(mappedSelectedFileFields, (o) => {
                                                                return o.property === mp.property
                                                            }).selectedFileField;
                                                            const alreadyUsedSelectedFileField = mappedSelectedFileFields && mappedSelectedFileFields.map((o) => { return o.selectedFileField });
                                                            const selectedFileFieldsToDisplay = selectedFileField ? concat(
                                                                selectedFileField,
                                                                difference(selectedFileFields, alreadyUsedSelectedFileField)
                                                            ) : difference(selectedFileFields, alreadyUsedSelectedFileField);
                                                            const options = selectedFileFieldsToDisplay && selectedFileFieldsToDisplay.map(field => { return { value: field, label: field } });
                                                            return (
                                                                <MappingRow key={`mappingRecord-${idx}`}>
                                                                    <div>
                                                                        <FormControl
                                                                            value={mp.display}
                                                                            disabled
                                                                            type={"text"}
                                                                            size="sm"
                                                                        />
                                                                    </div>
                                                                    <div>
                                                                        <FormSelect
                                                                            options={options}
                                                                            onChange={(v) => handleOnMappingSelectNew(mp.property, v ? v.value : null, mp.required)}
                                                                            value={{ value: selectedFileField, label: selectedFileField }}
                                                                            isClearable={!!selectedFileField}
                                                                            placeholder={'Select a field'}
                                                                            size="sm"
                                                                        />
                                                                    </div>
                                                                    <div style={{ minWidth: 0 }}>
                                                                        {/* Error message if missing column */}
                                                                        {mappingErrors[mp.property] && (
                                                                            <CustomTooltip bg={'#fff5f5'} fg={'#e53e3e'} border={'#fed7d7'}>
                                                                                <div className="scrollable-content">
                                                                                    <span style={{ 
                                                                                        color: '#e53e3e', 
                                                                                        fontSize: '0.875rem',
                                                                                        lineHeight: '1.25rem',
                                                                                        fontWeight: '500',
                                                                                        padding: '5px 0',
                                                                                        display: 'inline-flex',
                                                                                        alignItems: 'center',
                                                                                        cursor: 'help'
                                                                                    }}>
                                                                                        <span style={{ display: 'inline-flex', width: '1em', height: '1em', lineHeight: '1', alignItems: 'center', justifyContent: 'center', textAlign: 'center', marginRight: 6 }}>⚠️</span>
                                                                                        {mappingErrors[mp.property]}
                                                                                    </span>
                                                                                </div>
                                                                                <div className="tooltip-content">
                                                                                    {mappingErrors[mp.property]}
                                                                                </div>
                                                                            </CustomTooltip>
                                                                        )}
                                                                        {/* Override info if selection differs from source */}
                                                                        {originalSourceMapping && originalSourceMapping[mp.property] && selectedFileField && originalSourceMapping[mp.property] !== selectedFileField && (
                                                                            <CustomTooltip bg={'#e8f5e9'} fg={'#2e7d32'} border={'#94c399'}>
                                                                                <div className="scrollable-content">
                                                                                    <span style={{ 
                                                                                        color: '#2e7d32', 
                                                                                        fontSize: '0.875rem',
                                                                                        lineHeight: '1.25rem',
                                                                                        fontWeight: '500',
                                                                                        display: 'inline-flex',
                                                                                        alignItems: 'center',
                                                                                        cursor: 'help'
                                                                                    }}>
                                                                                        This selection differs from the source mapping: {originalSourceMapping[mp.property]}
                                                                                    </span>
                                                                                </div>
                                                                                <div className="tooltip-content">
                                                                                    This selection differs from the source mapping: {originalSourceMapping[mp.property]}
                                                                                </div>
                                                                            </CustomTooltip>
                                                                        )}
                                                                    </div>
                                                                </MappingRow>
                                                            )
                                                        })}
                                                        <StyledRow>
                                                            <Col xl={12} lg={12} md={12} sm={12} className="buttons">
                                                                <Button
                                                                    className="btn-min-width-120 btn-height-35"
                                                                    variant="outline-secondary"
                                                                    onClick={handleMapByName}
                                                                >MAP BY NAME
                                                                </Button>
                                                            </Col>
                                                        </StyledRow>
                                                    </>
                                                )}
                                            </MappingContainer>
                                        </Col>
                                    </StyledRow>
                        </Col>
                        <Col xl={4} lg={4} md={4} sm={4}>
                            <HelpPanel
                                        title=""
                                        height="200vh"
                                        data={[
                                            { property: 'source', description: 'The source this input is associated with' },
                                            { property: 'type', description: 'The type of input (automatically set based on source)' },
                                            { property: 'inputType', description: 'The specific input type (automatically set based on source)' },
                                            { property: 'name', description: 'Internal name for the input, not exposed to users' },
                                            { property: 'label', description: 'External label that will be shown to end users' },
                                            { property: 'description', description: 'Description of what this input represents' },
                                            { property: 'url', description: 'URL documenting where this input data comes from' },
                                            { property: 'qualityScore', description: 'Quality score for this input (0.0 to 1.0)' },
                                            { property: 'authoritative', description: 'Whether this input is considered authoritative' },
                                            { property: 'public', description: 'Whether this input is publicly accessible' },
                                            { property: 'products', description: 'Which products this input is associated with' },
                                            { property: 'indicators', description: 'Which indicators this input provides data for' },
                                            { property: 'dataType', description: 'Format of the data (CSV, Avro, Parquet)' },
                                            { property: 'dataChannel', description: 'How data is provided (Upload or S3)' }
                                        ]}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col xl={12} lg={12} md={12} sm={12} className="buttons">
                                    <Button
                                        className="btn-min-width-120 btn-height-35"
                                        variant="info"
                                        onClick={() => handleCreateInput()}
                                    >CREATE
                                    </Button>
                                    <Button
                                        className="btn-min-width-120 btn-height-35"
                                        style={{ marginLeft: "10px" }}
                                        variant="outline-secondary"
                                        onClick={() => navigate('/admin/inputs')}
                                    >CANCEL
                                    </Button>
                                </Col>
                            </Row>
                        </Form.Group>
                    </Form>
                </FormContainer>
            </Panel>
        </Container>
    );
}
